import { COMMUNITIES_QUERY } from 'schema-v2/Site/queries';
import { UNIFIED_GRAPH } from 'utils/constants';
import { truncateText } from 'utils/textHelpers';

import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import { useCommunityContext } from 'components/CommunityContext';

export const MAX_COMMUNITY_NAME_LENGTH = 22;

export const useCommunitySwitcher = () => {
  const { trackEvent, community } = useCommunityContext();

  const { data } = useQuery(COMMUNITIES_QUERY, {
    context: { clientName: UNIFIED_GRAPH },
  });

  const { communities, restOfCommunities } = useMemo(() => {
    const rawCommunities = data?.site?.communities?.edges?.map((item) => item.node) || [];

    /*
      Sort communities by published status first (Published first, then Drafts), 
      then alphabetically within each group
    */
    const sortedCommunities = [...rawCommunities].sort((a, b) => {
      if (a.published !== b.published) {
        return a.published ? -1 : 1;
      }

      // If published status is the same, sort alphabetically by name
      return (a.name || '').localeCompare(b.name || '');
    });

    const communitiesWithEncodedId = sortedCommunities.map((item) => ({
      ...item,
      id: btoa(`Community-${item.id}`),
      name: truncateText(item.name, MAX_COMMUNITY_NAME_LENGTH),
    }));

    const filteredCommunities = communitiesWithEncodedId.filter((item) => item.id !== community.id);

    return { communities: communitiesWithEncodedId, restOfCommunities: filteredCommunities };
  }, [data?.site?.communities?.edges, community.id]);

  return {
    community,
    communities,
    restOfCommunities,
    trackEvent,
  };
};
